exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-reads-js": () => import("./../../../src/pages/reads.js" /* webpackChunkName: "component---src-pages-reads-js" */),
  "component---src-pages-writings-js": () => import("./../../../src/pages/writings.js" /* webpackChunkName: "component---src-pages-writings-js" */)
}

